import { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { Header } from "@/components/Header";
import { StatusBadge } from "@/components/StatusBadge";
import client from "@/api";
import { useNavigate } from "react-router-dom";
import { BookOpen, ChevronRight } from "lucide-react";

export default function Chapters() {
  const { t, lang } = useApp();
  const navigate = useNavigate();
  const [chapters, setChapters] = useState(null);

  useEffect(() => {
    client.get(`/chapters?lang=${lang}`).then(({ data }) => setChapters(data.chapters)).catch(() => setChapters([]));
  }, [lang]);

  const byArea = {};
  (chapters || []).forEach((c) => { (byArea[c.area] = byArea[c.area] || { title: c.area_title, items: [] }).items.push(c); });

  return (
    <div className="min-h-screen bg-[#0d0d0d] bg-grain">
      <Header />
      <main className="max-w-5xl mx-auto px-4 sm:px-8 py-10">
        <h1 className="font-serif text-3xl sm:text-4xl text-[#FFFFFF] mb-8">{t("chapters_title")}</h1>
        {!chapters ? <div className="space-y-3 animate-pulse">{[...Array(6)].map((_, i) => <div key={i} className="h-16 bg-[#1a1a1a] rounded-xl" />)}</div> :
          Object.entries(byArea).map(([area, grp]) => (
            <div key={area} className="mb-10">
              <div className="text-xs uppercase tracking-widest text-[#D21F2A] mb-3">{grp.title}</div>
              <div className="space-y-2">
                {grp.items.map((c) => (
                  <button key={c.chapter_id} data-testid={`chapter-row-${c.chapter_id}`}
                    onClick={() => navigate(`/chapters/${c.chapter_id}`)}
                    className="w-full flex items-center gap-4 px-4 py-4 rounded-xl bg-[#141414] border border-[#D21F2A]/10 hover:border-[#D21F2A]/40 transition-colors text-left group">
                    <span className="font-serif text-lg text-[#D21F2A] w-8">{String(c.order).padStart(2, "0")}</span>
                    <BookOpen className="w-5 h-5 text-[#9AA0A6] shrink-0" />
                    <div className="flex-1 min-w-0">
                      <div className="text-[#FFFFFF] truncate">{c.title}</div>
                      <div className="text-xs text-[#9AA0A6] mt-0.5">
                        {t("source_pdf")} {c.pdf_pages}
                        {" · "}{t("best")}: {c.best_percent != null ? `${c.best_percent}%` : t("not_rated")}
                        {" · "}{t("last")}: {c.last_percent != null ? `${c.last_percent}%` : "–"}
                      </div>
                    </div>
                    <StatusBadge status={c.status} label={t(`status_${c.status}`)} testid={`chapter-status-${c.chapter_id}`} />
                    <ChevronRight className="w-5 h-5 text-[#9AA0A6] group-hover:text-[#D21F2A] transition-colors" />
                  </button>
                ))}
              </div>
            </div>
          ))}
      </main>
    </div>
  );
}
